import { CatalogBuilder } from "../../../../commonGroupModuleStructure/catalogBuilder";
import { ICatalogBuilder } from "../../../../commonGroupModuleStructure/catalogBuilder.entity";
import { featuresFeatureAccessMapping } from "../apiCall";
import { FeaturesKeys } from "../entity";

export const FeatureAccess = (props: any) => {
  const { request } = props;

  const column: ICatalogBuilder['pagingColumns'] = [
    {
      field: "DisplayName",
      headerName: "Name",
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
    {
      field: "Attribute",
      headerName: "Attribute",
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
  ];

  return (
    <CatalogBuilder
      isHeader={false}
      isAssociationButton={true}
      isPlusButton={false}
      isDefaultActionButton={false}

      getPagingData={featuresFeatureAccessMapping}
      pagingAPIrequest={request}
      pagingAPIKey={FeaturesKeys.getFeatureAccess}

      pagingColumns={column}

    />
  );
}   